import React from "react";

/**
 * Small italic hint under a title, e.g. what a form needs to be submitted.
 * Used instead of marking each required field.
 *
 * @param {{children: React.ReactNode, className?: string}} props
 */
const Subtitle = ({children, className = "mb-3"}) => (
    <p className={`text-muted small fst-italic ${className}`}>{children}</p>
);

export default Subtitle;
